import { Injectable } from '@angular/core';
import { Directive, ElementRef, HostListener, Output, EventEmitter } from '@angular/core';

/**
 * Disable the button then re-enable it.
 * Can be used on forms.
 * i.e.
 * component -> someFunction(httpClickHandler: HttpClickHandler)
 * view -> (appHttpClick)="someFunction($event)"
 * 
 */
@Directive({
  selector: '[appHttpClick]'
})
export class HttpClickDirective {
  @Output("appHttpClick") callback: EventEmitter<any> = new EventEmitter<any>();

  httpClickHandler: HttpClickHandler;
  isForm: boolean;
  constructor(el: ElementRef) {
    this.httpClickHandler = new HttpClickHandler();
    this.isForm = el.nativeElement.tagName === "FORM";
  }

  @HostListener('click', ['$event']) onClick(e) {
    if (this.isForm || this.httpClickHandler.isDisabled) {
      return;
    }
    this.httpClickHandler.disable();
    this.callback.emit(this.httpClickHandler);
  }
  @HostListener('submit', ['$event']) onSubmit(e) {
    if (!this.isForm || this.httpClickHandler.isDisabled) {
      return;
    }
    this.httpClickHandler.disable();
    this.callback.emit(this.httpClickHandler);
  }
}

@Injectable()
export class HttpClickHandler {
  isDisabled: boolean;
  constructor() {
    this.isDisabled = false;
  }
  enable() {
    this.isDisabled = false;
  }
  disable() {
    this.isDisabled = true;
  }
}
